<div style="display: flex; flex-direction: column;" *ngIf="user$ | async as user">
    <kendo-expansionpanel *ngFor="let panel of taskViewModel; index as i" [title]="getTaskHeader(panel) ?? ''"
        [expanded]="((panel?.startDate || panel?.queue_Start) && !panel?.completeDate) ?? false">
        <div style="display: flex;">
            <div nz-row style="width: 100%;">
                <kendo-stacklayout [orientation]="'horizontal'" [gap]="10" style="width: 100%;">
                    <div class="k-flex-20">
                        <h5>User</h5>
                        <kendo-dropdownlist placeholder="Search Employee" [(ngModel)]="panel.user_Id"
                            style="width:75%;" *ngIf="panel.isEdit" [data]="(employees | async) ?? []" textField="name"
                            valueField="id" [kendoDropDownFilter]="filterSettings" [valuePrimitive]="true">
                        </kendo-dropdownlist>
                        <span *ngIf="!panel.isEdit"><i>{{panel.displayName}}</i></span>
                    </div>
                    <div class="k-flex-50" style="display: flex;">
                        <div style="width: 100%;">
                            <div style="text-align: center; margin-bottom: 0.5rem;">
                                <h5>Overall Process Time</h5>
                            </div>

                            <div
                                style="display: flex; justify-content: space-between; align-items: center; width: 100%;">

                                <div style="width: 49%;">
                                    <kendo-datetimepicker #datetimepickerStart [value]="panel.startDate ? convertUTCDateToLocalDate(panel.startDate) : null"
                                        [disabled]="isTaskDateDisabled(panel, 'Start')" [(ngModel)]="updatedStartDate" format="yyyy-MM-dd HH:mm:ss">
                                    </kendo-datetimepicker>
                                </div>

                                <div style="width: 2%; text-align: center;">
                                    <span class="k-icon k-font-icon k-i-arrow-chevron-right"></span>
                                </div>

                                <div style="width: 49%;">
                                    <kendo-datetimepicker #datetimepickerEnd [value]="panel.completeDate ? convertUTCDateToLocalDate(panel.completeDate) : null"
                                        [disabled]="isTaskDateDisabled(panel, 'Complete')" [(ngModel)]="updatedCompleteDate" format="yyyy-MM-dd HH:mm:ss">
                                    </kendo-datetimepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="k-flex-20" style="align-items: center;">
                        <ng-container *ngIf="user?.Routes?.includes('RTA_PROCESSOR')">
                            <button kendoButton fillMode="outline" themeColor="primary" (click)="StartTask(panel)"
                                *ngIf="!panel?.startDate && panel?.queue_Start && !panel.isEdit && !onHold"><span
                                    class="k-icon k-font-icon k-i-loading k-icon-xl" *ngIf="isLoadingTaskProcessing"></span><span
                                    *ngIf="!isLoadingTaskProcessing">Click to Start</span></button>
                            <button kendoButton fillMode="outline" themeColor="success" (click)="CompleteTask(panel)"
                                *ngIf="panel?.startDate && !panel?.completeDate && panel?.queue_Start && !panel.isEdit && !onHold && !isApprovalProcess(panel)"><span
                                    class="k-icon k-font-icon k-i-loading k-icon-xl" *ngIf="isLoadingTaskProcessing"></span><span
                                    *ngIf="!isLoadingTaskProcessing">Click to Complete</span></button>

                            <!-- Approval task buttons (only shown if user has permission) -->
                            <button kendoButton fillMode="solid" themeColor="success" (click)="ApproveTask(panel)"
                                *ngIf="isApprovalProcess(panel) && canApproveTask(panel) && panel?.queue_Start && !panel?.completeDate && !panel.isEdit && !onHold"
                                [disabled]="isLoadingTaskProcessing"><span
                                    class="k-icon k-font-icon k-i-check" *ngIf="!isLoadingTaskProcessing"></span><span
                                    *ngIf="!isLoadingTaskProcessing"> Approve</span><span
                                    *ngIf="isLoadingTaskProcessing">Processing...</span></button>
                            <button kendoButton fillMode="solid" themeColor="error" (click)="showRejectDialog(panel)"
                                *ngIf="isApprovalProcess(panel) && canApproveTask(panel) && panel?.queue_Start && !panel?.completeDate && !panel.isEdit && !onHold"
                                [disabled]="isLoadingTaskProcessing"><span
                                    class="k-icon k-font-icon k-i-close" *ngIf="!isLoadingTaskProcessing"></span><span
                                    *ngIf="!isLoadingTaskProcessing"> Reject</span></button>
                            <!-- Pending approval label for users without permission -->
                            <span class="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-warning"
                                *ngIf="isApprovalProcess(panel) && !canApproveTask(panel) && panel?.queue_Start && !panel?.completeDate && !panel.isEdit && !onHold">
                                <span class="k-chip-content">Pending Approval</span>
                            </span>

                        </ng-container>
                        
                    </div>
                    <div class="k-flex-10" style="align-items: center;">
                        <ng-container *ngIf="user?.Routes?.includes('RTA_TASK_MANAGER')">
                            <kendo-svgicon [icon]="pencilIcon" size="large" title="Edit task" (click)="ShowEditTask(i)" style="margin-right:5px; cursor: pointer;" *ngIf="!panel.isEdit && panel?.queue_Start && !panel?.completeDate && !onHold"></kendo-svgicon>
                            <kendo-svgicon [icon]="trashIcon" size="large" title="Delete entire process" (click)="showDeleteProcessConfirm(panel)" style="margin-right:5px; cursor: pointer; color: #dc2626;" *ngIf="canDeleteProcess(panel) && !panel.isEdit && !onHold"></kendo-svgicon>
                        </ng-container>
                        <kendo-svgicon [icon]="xIcon" size="large" title="Cancel edit" (click)="panel.isEdit=false" style="margin-right:5px; cursor: pointer;" *ngIf="panel.isEdit && panel?.queue_Start && !panel?.completeDate && !onHold"></kendo-svgicon>
                        <kendo-svgicon [icon]="saveIcon" size="large" title="Save task" (click)="UpdateTask(panel)" style="margin-right:5px; cursor: pointer;" *ngIf="panel.isEdit && panel?.queue_Start && !panel?.completeDate && !onHold"></kendo-svgicon>   
                        <kendo-svgicon kendoPopoverAnchor #anchor="kendoPopoverAnchor" [popover]="onHoldInfo" [icon]="clockIcon" size="large" title="Display on hold data" style="margin-right:5px; cursor: pointer;" *ngIf="(panel?.onHoldData ?? []).length > 0"></kendo-svgicon>   
                        <kendo-svgicon [icon]="handIcon" size="large" title="Place task on hold" (click)="ShowOnHold(panel)" style="margin-right:5px; cursor: pointer;" *ngIf="!onHold && panel?.queue_Start && !panel?.completeDate"></kendo-svgicon>
                        <kendo-popover #onHoldInfo position="bottom" title="On Hold Data" [width]="300">
                            <ng-template kendoPopoverBodyTemplate>
                              <div style="max-height: 300px; overflow-y: auto; padding-right: 8px;">
                                <div *ngFor="let onhold of panel.onHoldData">
                                  <p *ngIf="onhold?.removed">
                                    {{ onhold.user }} placed on hold on
                                    {{ onhold.start ? (convertUTCDateToLocalDate(onhold.start) | date:'MM/dd/YYYY') : 'Invalid Date' }}
                                    for {{ getTimeSpanofOnHold(onhold.start, onhold.removed) }} for
                                    <i style="font-weight: bold;">{{ onhold.reason }}</i>
                                  </p>
                                  <p *ngIf="!onhold?.removed">
                                    {{ onhold.user }} placed on hold on
                                    {{ onhold.start ? (convertUTCDateToLocalDate(onhold.start) | date:'MM/dd/YYYY') : 'Invalid Date' }}
                                    and is still on hold for
                                    <i style="font-weight: bold;">{{ onhold.reason }}</i>
                                  </p>
                                </div>
                              </div>
                            </ng-template>
                          </kendo-popover>
    
                        <ng-container *ngIf="user?.Routes?.includes('RTA_TASK_ROLLBACK') && !onHold && !panel?.completeDate">
                            <kendo-svgicon [icon]="arrowRotateCwIcon" size="large" title="Rollback current task progress" *ngIf="showRollback(panel)" 
                            (click)="panel.isEdit=false" style="margin-right:5px; cursor: pointer;" (click)="RollbackTask(panel)"></kendo-svgicon>
                        </ng-container>
                        <ng-container *ngIf="user?.Routes?.includes('RTA_TASK_ROLLBACK') && !onHold && (panel?.subTasks ?? []).length > 0">
                            <kendo-svgicon [icon]="rotateIcon" size="large" title="Rollback current sub-task progress" *ngIf="showRollbacksubTask(panel)" 
                            (click)="panel.isEdit=false" style="margin-right:5px; cursor: pointer;" (click)="RollBackSubTask(panel)"></kendo-svgicon>
                        </ng-container>
                        <ng-container *ngIf="user?.Routes?.includes('RTA_TASK_REWORK') && !onHold">
                            <span nz-icon nzType="branches" style="margin-right:5px; cursor: pointer;" nzTheme="outline"
                                *ngIf="showRollback(panel)" title="Send back for rework" nz-popconfirm
                                nzPopconfirmTitle="Are you sure you want to send back for rework?"
                                nzPopconfirmPlacement="bottom" (nzOnConfirm)="confirmRework(panel)"></span>
                        </ng-container>
                    </div>
                </kendo-stacklayout>

                <kendo-grid [kendoGridBinding]="getTaskOrdered(panel.subTasks || [])" [pageable]="false"
                    [size]="smallSize" style="margin-top: 10px;" *ngIf="(panel?.subTasks ?? []).length > 0">
                    <kendo-grid-column field="processName" title="Process"> </kendo-grid-column>
                    <kendo-grid-column field="displayName" title="User"> </kendo-grid-column>
                    <kendo-grid-column field="notes" title="Notes"> </kendo-grid-column>
                    <kendo-grid-column field="queue_Start" title="Queued"><ng-template kendoGridCellTemplate
                            let-dataItem>
                            {{convertUTC(dataItem?.queue_Start) | date:'MM/dd/YYYY HH:mm'}}
                        </ng-template></kendo-grid-column>
                    <kendo-grid-column field="startDate" title="Start"><ng-template kendoGridCellTemplate let-dataItem>
                            {{convertUTC(dataItem?.startDate) | date:'MM/dd/YYYY HH:mm'}}
                        </ng-template></kendo-grid-column>
                    <kendo-grid-column field="completeDate" title="Complete"><ng-template kendoGridCellTemplate
                            let-dataItem>
                            {{convertUTC(dataItem?.completeDate) | date:'MM/dd/YYYY HH:mm'}}
                        </ng-template></kendo-grid-column>
                    <kendo-grid-column title="Status">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span *ngIf="!dataItem?.startDate && dataItem?.queue_Start && !dataItem?.displayName"
                                style="color: #00b7c4;">Pending Start</span>
                            <span *ngIf="!dataItem?.startDate && dataItem?.displayName"
                                style="color: #c47500;">Assigned</span>
                            <span *ngIf="dataItem?.startDate && !dataItem?.completeDate"
                                style="color: #0036ca;">Processing...</span>
                            <span *ngIf="dataItem?.completeDate" style="color: #00ca54;">Completed</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column>
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <ng-container *ngIf="user?.Routes?.includes('RTA_PROCESSOR')">
                                <button kendoButton class="smallSize" (click)="StartTask(dataItem)" themeColor="primary" [disabled]="isLoadingTaskProcessing"
                                    fillMode="outline" [size]="'small'"
                                    *ngIf="!dataItem?.startDate && dataItem?.queue_Start && !onHold">
                                    <span class="k-icon k-font-icon k-i-loading k-icon-xl" *ngIf="isLoadingTaskProcessing"></span>
                                    Click to Start
                                </button>
                                <button kendoButton class="smallSize" themeColor="primary" fillMode="outline" [disabled]="isLoadingTaskProcessing"
                                    [size]="'small'" (click)="CompleteTask(dataItem)"
                                    *ngIf="dataItem?.startDate && !dataItem?.completeDate && !onHold">
                                    <span class="k-icon k-font-icon k-i-loading k-icon-xl" *ngIf="isLoadingTaskProcessing"></span>
                                    Click to Complete
                                </button>
                            </ng-container>

                            <!-- <ng-template #elseTemplate>
                <button kendoButton class="smallSize" (click)="CheckUser(dataItem, 'start')"
                themeColor="primary" fillMode="outline" [size]="smallSize"
                  *ngIf="dataItem.startDate === null && dataItem.queue_Start !== null && !dataItem.isEdit && !onHold">
                  Sign in to Start
                </button>
                <button kendoButton class="smallSize"
                themeColor="primary" fillMode="outline" [size]="smallSize"
                  (click)="CheckUser(dataItem, 'complete')" 
                  *ngIf="dataItem?.startDate && dataItem?.completeDate && !dataItem?.queue_Start && !dataItem.isEdit && !onHold">
                  Sign in to Complete
                </button>
              </ng-template> -->
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="" [width]="60">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <ng-container *ngIf="user?.Routes?.includes('RTA_TASK_MANAGER')">
                                <kendo-svgicon [icon]="trashIcon" size="medium" title="Delete task"
                                    (click)="showDeleteTaskConfirm(dataItem)"
                                    style="cursor: pointer; color: #dc2626;"
                                    *ngIf="canDeleteTask(dataItem)"></kendo-svgicon>
                            </ng-container>
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </kendo-expansionpanel>
</div>
@if (showRework) {
<kendo-dialog title="Select processes for rework" (nzOnOk)="processRework()" (close)="showRework=false">
    <br />
    Rework tree will be generated based on the selected processes.
    <br />
    <br />
    <kendo-dialog-actions>
        <button kendoButton (click)="showRework=false">Cancel</button>
        <button kendoButton (click)="processRework()" themeColor="primary">
            Process Rework
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
}
@if(showOnHold){
    <kendo-dialog
    title="Onhold Confirmation"
    (close)="CancelOnHold()"
    autoFocusedElement="#addtionalHoldInfo"
    [minWidth]="250"
    [width]="450"
  >
  <form class="k-form k-form-md" [formGroup]="onHold_Form">
    <div class="row">
        <div class="col-lg-6">
          <kendo-textbox formControlName="order_Id" hidden="true"></kendo-textbox>
          <kendo-label text="Hold Date"></kendo-label>
          <div kendoTypography variant="h4" style="color: darkorange;">{{this.holdDate| date:'MMM dd yyyy'}}</div>
        </div>
        <div class="col-lg-6">
          <kendo-label text="Hold By"></kendo-label>
          <div kendoTypography variant="h4" style="color: darkorange;">REPLACE ME</div>
        </div>
      </div>
      <div>
        <kendo-label text="Hold Category">
          <kendo-dropdownlist [data]="(onHoldCategories$ | async)" textField="Name" valueField="value" [valuePrimitive]="true" formControlName="onHoldCat_Id"></kendo-dropdownlist>
        </kendo-label>
      </div>
      <div nz-row>
        <div nz-col nzSpan="24">
          <kendo-label text="Additional Information" [optional]="true">
            <kendo-textarea id="addtionalHoldInfo" placeholder="Enter addtional supporting information on the reason for the hold..." [rows]="3" formControlName="reason"></kendo-textarea>
          </kendo-label>
        </div>
      </div>
  </form>
  
    <kendo-dialog-actions>
      <button kendoButton (click)="CancelOnHold()">Cancel</button>
      <button kendoButton (click)="handleonholdOk()" themeColor="primary">
        Initiate Hold
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
<kendo-dialog *ngIf="showDiagRollbackSubTask" (close)="showDiagRollbackSubTask = false" [minWidth]="250" [width]="450">
    <p style="margin: 30px; text-align: center;">
        Are you sure you want to rollback this task?
    </p>
    <kendo-dialog-actions>
        <button kendoButton (click)="showDiagRollbackSubTask = false">No</button>
        <button kendoButton themeColor="primary">
            Yes
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!-- Rejection Reason Dialog -->
@if(showRejectReasonDialog) {
<kendo-dialog title="Reject Approval Task" (close)="cancelRejectDialog()" [minWidth]="300" [width]="500">
    <div style="padding: 8px 0;">
        <p style="margin: 0 0 16px 0; font-size: 14px; color: #64748b;">
            Please provide a reason for rejecting this request. The submitter will be notified via email.
        </p>
        <kendo-textarea [(ngModel)]="rejectReason" [rows]="4" placeholder="Enter rejection reason..." style="width: 100%;"></kendo-textarea>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="cancelRejectDialog()">Cancel</button>
        <button kendoButton themeColor="error" (click)="confirmRejectTask()" [disabled]="!rejectReason.trim()">
            Confirm Rejection
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
}

<!-- NC (Programming) Choice Dialog -->
@if(showNCDialog) {
<kendo-dialog title="Finalize RTA – Programming Check" (close)="cancelNCDialog()" [minWidth]="350" [width]="520">
    <div style="padding: 16px 0; text-align: center;">
        <p style="margin: 0 0 20px 0; font-size: 14px; color: var(--kendo-color-on-app-surface, #374151); line-height: 1.6;">
            Before completing the <strong>Finalize RTA</strong> task, please indicate whether 
            <strong>Programming (NC)</strong> process is required for this request.
        </p>
        <div style="display: flex; justify-content: center; gap: 16px; margin-top: 8px;">
            <button kendoButton themeColor="warning" fillMode="solid" (click)="onNCRequired()"
                [disabled]="isLoadingTaskProcessing" style="min-width: 160px; padding: 10px 24px; font-size: 14px;">
                <span class="k-icon k-font-icon k-i-loading k-icon-xl" *ngIf="isLoadingTaskProcessing"></span>
                <span *ngIf="!isLoadingTaskProcessing">NC Required</span>
            </button>
            <button kendoButton themeColor="success" fillMode="solid" (click)="onNCNotRequired()"
                [disabled]="isLoadingTaskProcessing" style="min-width: 160px; padding: 10px 24px; font-size: 14px;">
                <span *ngIf="!isLoadingTaskProcessing">NC NOT Required</span>
            </button>
        </div>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="cancelNCDialog()">Cancel</button>
    </kendo-dialog-actions>
</kendo-dialog>
}

<!-- Delete Task/Process Confirmation Dialog -->
@if(showDeleteConfirmDialog) {
<kendo-dialog title="Confirm Deletion" (close)="cancelDeleteConfirm()" [minWidth]="300" [width]="480">
    <div style="padding: 16px 0; text-align: center;">
        <span class="k-icon k-font-icon k-i-warning" style="font-size: 48px; color: #dc2626; display: block; margin-bottom: 16px;"></span>
        <p style="margin: 0; font-size: 14px; color: var(--kendo-color-on-app-surface, #374151); line-height: 1.6;">
            {{ deleteConfirmMessage }}
        </p>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="cancelDeleteConfirm()">Cancel</button>
        <button kendoButton themeColor="error" (click)="confirmDelete()">
            Delete
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
}